<template>
  <a-card :bordered="false">
    <!-- 顶部筛选区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="按钮名称">
              <a-input v-model="queryParam.text" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :md="!advanced && 8 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 上部功能导航 -->
    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleAdd()">新建</a-button>
      <a-button type="dashed" v-if="config.hasAlert" @click="tableOption">{{ optionAlertShow && '关闭' || '开启' }} alert</a-button>
    </div>

    <!-- 数据网格 -->
    <s-table
      ref="table"
      size="default"
      :bordered="config.globlaBordered"
      :rowKey="(record) => record.id"
      :columns="columns"
      :data="loadData"
      :alert="options.alert"
      :pagination="{pageSizeOptions:pageSizeOptionsList,showTotal:total => `共${total}条`}"
      :rowSelection="options.rowSelection">
      <span slot="serial" slot-scope="text, record, index">
        {{ index + 1 }}
      </span>
      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">编辑</a>
        <a-divider type="vertical"/>
        <a-dropdown>
          <a class="ant-dropdown-link"> 更多<a-icon type="down"/></a>
          <a-menu slot="overlay">
            <a-menu-item><a @click="handleDel(record)">删除</a></a-menu-item>
          </a-menu>
        </a-dropdown>
      </span>
    </s-table>

    <a-modal title="编辑" style="top: 20px;" :width="560" v-model="visible" @ok="handleOk" :confirmLoading="confirmLoading">
      <a-form :form="form">
        <a-form-item label="按钮名称" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input
            v-model="mdl.text"
            placeholder="按钮名称"
            v-decorator="['text',
            { initialValue: mdl.text, rules: [{ required: true, message: '请输入按钮名称'}]}]" />
        </a-form-item>

        <a-form-item label="按钮编码" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input
            v-model="mdl.code"
            placeholder="按钮编码"
            v-decorator="['code',
            { initialValue: mdl.code, rules: [{ required: true, message: '请输入按钮编码'}]}]" />
        </a-form-item>

        <a-form-item label="按钮图片" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input
            v-model="mdl.icon"
            placeholder="按钮图片"
            v-decorator="['icon',
            { initialValue: mdl.icon, rules: [{ required: true, message: '请输入按钮图片'}]}]" />
        </a-form-item>

         
        <a-form-item label="按钮url" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }" v-if="mdl.code !='sys_hwl'">
          <a-input
            v-model="mdl.url"
            placeholder="按钮url"
            v-decorator="['url',
            { initialValue: mdl.url, rules: [{ required: true, message: '请输入按钮url'}]}]" />
        </a-form-item>
        
            <a-form-item label="切换模式" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }" v-if="mdl.code =='sys_hwl'">
         <a-select
            :filterOption="filterOption"
            v-model="mdl.url"
            placeholder="请选择切换模式"
            v-decorator="['url', { initialValue: mdl.url, rules: [{ required: true, message: '切换模式'}]}]"
          >
            <a-select-option value>请选择</a-select-option>
            <a-select-option value="一次">一次</a-select-option>
            <a-select-option value="永久">永久</a-select-option>
          </a-select>
        </a-form-item>
         

        <a-form-item label="排序" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input type="number"
            v-model="mdl.sort"
            placeholder=""
            v-decorator="['sort',
            { initialValue: mdl.sort, rules: [{ required: true, message: '排序'}]}]" />
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
  import { STable } from '@/components'
  import {  buttonPage, buttonUpdate, buttonSave, buttonDelete } from '@/api/sys'
  import moment from 'moment';
  import { formatDate } from '@/utils/date'

  export default {
    name: 'WxButton',
    components: {
      STable
    },
    data () {
      return {
        pageSizeOptionsList:['10'],
        visible: false,
        confirmLoading: false,
        accredit: false,
        form: this.$form.createForm(this),
        mdl: {},
        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {},
        // 表头
        columns: [
          {
            title: '按钮名称',
            dataIndex: 'text'
          },
          {
            title: '按钮编码',
            dataIndex: 'code'
          },
          {
            title: '按钮图片',
            dataIndex: 'icon'
          },
          {
            title: '按钮url',
            dataIndex: 'url'
          },
          {
            title: '排序',
            dataIndex: 'sort'
          },
          {
            title: '操作',
            width: '13y0px',
            dataIndex: 'action',
            scopedSlots: { customRender: 'action' }
          }
        ],

        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          return buttonPage(Object.assign(parameter, this.queryParam))
            .then(res => {
              return res.data
            })
        },

        selectedRowKeys: [],
        selectedRows: [],
        // 所属菜单下拉
        typeSelect: null,
        // 厂区下拉
        factorySelect: null,
        // 审核状态下拉
        accreditSelect: null,

        // custom table alert & rowSelection
        options: {
          alert: { show: false, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        },
        optionAlertShow: true
      }
    },
    created () {
      this.tableOption()
      this.loadSelect()
    },
    methods: {
      moment,
      disabledDate(current) {
        // Can not select days before today and today
        return current && current < moment().endOf('day');
      },
      loadSelect () { // 从后台拉去下拉列表数据

      },
      filterOption (input, option) { // 用于下拉列表可搜索
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
      tableOption () {
        if (!this.optionAlertShow) {
          this.options = {
            alert: { show: false, clear: () => { this.selectedRowKeys = [] } },
            rowSelection: {
              selectedRowKeys: this.selectedRowKeys,
              onChange: this.onSelectChange
            }
          }
          this.optionAlertShow = true
        } else {
          this.options = {
            alert: false,
            rowSelection: null
          }
          this.optionAlertShow = false
        }
      },
      handleEdit (record) {
        this.mdl = Object.assign({}, record)
        this.form = this.$form.createForm(this)
        this.visible = true
      },
      handleAdd () {
        this.mdl = {}
        this.form = this.$form.createForm(this)
        this.visible = true
      },
      handleOk () {
        this.form.validateFields((err, values) => {
          if (!err) {
            this.confirmLoading = true
            if (this.mdl.id !== undefined) {
              buttonUpdate(Object.assign({}, this.mdl))
              .then(res => {
                if (res.code === '0') {
                  this.$refs.table.refresh()
                  this.visible = false
                }
              }).catch((e) => {
                console.log(e)
              }).finally(() => {
                this.confirmLoading = false
              })
            } else {
              buttonSave(Object.assign({}, this.mdl))
              .then(res => {
                if (res.code === '0') {
                  this.$refs.table.refresh()
                  this.visible = false
                }
              }).catch((e) => {
                console.log(e)
              }).finally(() => {
                this.confirmLoading = false
              })
            }
          }
        })
      },
      handleDel (record) {
        var nthis = this
        this.$confirm({
          title: '提示',
          content: '确定要删除吗?',
          onOk () {
            return buttonDelete({ 'id': record.id })
            .then(res => {
              if(res.code ==='0') {
                nthis.$refs.table.refresh()
              }
            }).catch((e) => {
              console.log(e)
            }).finally(() => {
            })
          },
          onCancel () {
          }
        })
      },
      onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },
      toggleAdvanced () {
        this.advanced = !this.advanced
      }
    }
  }
</script>
